import React from "react";

import { graphql } from "gatsby";

import KontentAssetsImage from "./kontentAssetsImage";
import NavigationLink from "../components/navigationLink/navigationLink";

interface KontentItemImageButtonProps {
  data: Queries.kontent_item_image_button;
  onClick?: (e: React.MouseEvent) => void;
  loading?: boolean;
}

const KontentItemImageButton: React.FC<KontentItemImageButtonProps> = ({
  data,
  onClick = () => {},
  loading = false,
}) => {
  if (!data || !data.elements) {
    return null;
  }

  const elements = data.elements!;

  return (
    <NavigationLink
      className="no-style img-button p-0"
      href={elements.url_extern?.value || ""}
      title={elements.title?.value || ""}
      onClick={onClick}
      loading={loading}
    >
      <KontentAssetsImage
        height={40}
        data={elements.image?.value?.[0] as Queries.kontent_item_asset_element}
      />
    </NavigationLink>
  );
};

export const query = graphql`
  fragment KontentItemImageButton on kontent_item_image_button {
    id
    system {
      codename
    }
    elements {
      image {
        value {
          url
          width
          type
          size
          name
          height
          description
        }
      }
      url_extern {
        value
      }
      title {
        value
      }
      note {
        value
      }
    }
  }
`;

export default KontentItemImageButton;
